<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h1>VUE D'ENSEMBLE</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="ibox" v-if="$root.isAuthorized('renting_index')">
          <routerLink :to="{
            name: 'RentingListByStatus',
            params: { status: 'renting-en-attente-de-traitement' },
          }">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Commandes</dt>
                  <dd>En attente</dd>
                </dl>
              </div>
              <h2>
                {{ this.renting_waiting }}
                <i class="far fa-long-arrow-right fa-xs"></i>
              </h2>
            </div>
          </routerLink>
        </div>
        <div class="ibox" v-if="$root.isAuthorized('business-return_index')">
          <routerLink :to="{
            name: 'BusinessReturnListByStatus',
            params: { status: 'business-return-en-attente' },
          }">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Demande de retour</dt>
                  <dd>En attente</dd>
                </dl>
              </div>
              <h2>
                {{
                  $store.getters["business_return/getByStatusSlug"]("business-return-en-attente")
                    .length
                }}
                <i class="far fa-long-arrow-left fa-xs"></i>
              </h2>
            </div>
          </routerLink>
        </div>
        <div class="ibox" v-if="$root.isAuthorized('reference_index')">
          <routerLink :to="{ name: 'OverdueMaintenanceReferenceList' }">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Références</dt>
                  <dd>En attente d'étalonnage</dd>
                </dl>
              </div>
              <h2>
                {{ overdue_maintenance_references_quantity }}
                <i class="far fa-wrench fa-xs"></i>
              </h2>
            </div>
          </routerLink>
        </div>
      </b-col>
      <b-col>
        <div class="ibox" v-if="$root.isAuthorized('renting_index')">
          <routerLink :to="{ name: 'RentingListByStatus', params: { status: 'renting-en-preparation' } }">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Commandes</dt>
                  <dd>En préparation</dd>
                </dl>
              </div>
              <h2>
                {{ this.renting_in_preparation }}
                <i class="far fa-long-arrow-right fa-xs"></i>
              </h2>
            </div>
          </routerLink>
        </div>
        <div class="ibox" v-if="$root.isAuthorized('shipping_index')">
          <routerLink :to="{ name: 'ShippingListByStatus', params: { status: 'shipping-en-preparation' } }">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Fiches d'expédition</dt>
                  <dd>En préparation</dd>
                </dl>
              </div>
              <h2>
                {{ $store.getters["shipping/getByStatusSlug"]("shipping-en-preparation").length }}
                <i class="far fa-truck fa-xs"></i>
              </h2>
            </div>
          </routerLink>
        </div>
        <div class="ibox" v-if="$root.isAuthorized('shipping_index')">
          <routerLink :to="{
            name: 'ShippingListByStatus',
            params: { status: 'shipping-en-attente-de-solution-de-transport' },
          }">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Fiches d'expédition</dt>
                  <dd>En attente de solution transport</dd>
                </dl>
              </div>
              <h2>
                {{
                  $store.getters["shipping/getByStatusSlug"](
                    "shipping-en-attente-de-solution-de-transport"
                  ).length
                }}
                <i class="far fa-truck fa-xs"></i>
              </h2>
            </div>
          </routerLink>
        </div>
      </b-col>
      <b-col>
        <div class="ibox ibox-focus-currentmonth" v-if="
          $root.isAuthorized('reference_index') ||
          $root.isAuthorized('renting_index') ||
          $root.isAuthorized('complaint_index')
        ">
          <div class="ibox-title">{{ $moment().format("MMMM Y").capitalize() }}</div>
          <div class="ibox-content">
            <ul class="list-group">
              <li class="list-group-item indicator" v-if="$root.isAuthorized('reference_index')">
                <div class="flex-grow-1">
                  <dl>
                    <dt>Références uniques</dt>
                    <dd>En location à date</dd>
                  </dl>
                </div>
                <h2>
                  {{ in_location_references_quantity }}
                  <i class="far fa-toolbox fa-xs"></i>
                </h2>
              </li>
              <li class="list-group-item indicator" v-if="$root.isAuthorized('renting_index')">
                <div class="flex-grow-1">
                  <dl>
                    <dt>Commandes</dt>
                    <dd>En {{ $moment().format("MMMM") }}</dd>
                  </dl>
                </div>
                <h2>
                  {{ this.renting_month }}
                  <i class="far fa-long-arrow-right fa-xs"></i>
                </h2>
              </li>
              <li class="list-group-item indicator" v-if="$root.isAuthorized('complaint_index')">
                <div class="flex-grow-1">
                  <dl>
                    <dt>Réclamations</dt>
                    <dd>En {{ $moment().format("MMMM") }}</dd>
                  </dl>
                </div>
                <h2>
                  {{
                    $store.getters["complaint/getByDate"](
                      $moment().startOf("month"),
                      $moment().endOf("month")
                    ).length
                  }}
                  <i class="far fa-comment-alt-exclamation fa-xs"></i>
                </h2>
              </li>
            </ul>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <!-- <div
          v-if="
            $root.isAuthorized(['external-maintenance_index'], true)
          "
          class="ibox"
        >
          <div class="ibox-title"><i class="far fa-wrench"></i>Maintenance prolongée</div>
          <div class="ibox-content p-0 pb-25">
            <table v-if="in_long_maintenance_references.length" class="table table-hover m-0">
              <thead>
                <tr>
                  <th>Ref. unique</th>
                  <th>Désignation</th>
                  <th>Retard (jours)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="reference in in_long_maintenance_references" :key="reference.id">
                  <td>
                    <router-link :to="{ name: 'ReferenceDetail', params: { id: reference.id } }">{{
                      reference.internal_code
                    }}</router-link>
                  </td>
                  <td>{{ reference.product.name }}</td>
                  <td>{{ reference.delay }}</td>
                </tr>
              </tbody>
            </table>
            <p v-else class="text-center mt-10 mb-0">Liste vide pour le moment</p>
          </div>
        </div> -->
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      minimum_stock_renting_products: [],
      minimum_stock_selling_products: [],
      overdue_maintenance_references_quantity: 0,
      in_long_maintenance_references: [],
      in_location_references_quantity: 0,
      renting_waiting: 0,
      renting_in_preparation: 0,
      renting_month: 0,
    };
  },
  mounted() {
    const self = this;
    if (this.$root.isAuthorized("renting_index")) {
      this.$store.dispatch("renting/getRentingDashboard").then((response) => {
        this.renting_waiting = response.data.dashboard['renting-en-attente-de-traitement'];
        this.renting_in_preparation = response.data.dashboard['renting-en-preparation'];
        this.renting_month = response.data.month['total'];
      });
    }
    if (this.$root.isAuthorized("business-return_index")) {
      this.$store.dispatch("business_return/getByStatusSlug", ["business-return-en-attente"]);
    }
    if (this.$root.isAuthorized("transfer_index")) {
      this.$store.dispatch("transfer/getByStatusSlug", ["transfer-demande"]);
    }
    if (this.$root.isAuthorized("shipping_index")) {
      this.$store.dispatch("shipping/getByStatusSlug", [
        "shipping-en-preparation",
        "shipping-en-attente-de-solution-de-transport",
      ]);
    }
    if (this.$root.isAuthorized("complaint_index")) {
      this.$store.dispatch("complaint/getAll");
    }
    if (this.$root.isAuthorized("reference_index")) {
      this.$store.dispatch("reference/getWaitingCalibrationQuantity").then((response) => {
        this.overdue_maintenance_references_quantity = response.data.total;
      });
    }
    if (this.$root.isAuthorized("reference_index")) {
      this.$store.dispatch("reference/getInLocationQuantity").then((response) => {
        this.in_location_references_quantity = response.data.total;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

.ibox a {
  color: $text;

  &:hover {
    color: $primary;
  }
}

.ibox-content {
  font-size: 12px;

  dl {
    margin-bottom: 0;

    dt {
      margin-bottom: 0;
    }

    dd {
      clear: both;
      @extend .clanprobold;
    }
  }
}

.ibox-focus-currentmonth {
  height: calc(100% - 25px);
  border: solid 1px $ibox-title;

  .ibox-content {
    padding-bottom: 0;
  }

  .list-group {
    margin-left: -25px;
    margin-right: -25px;
    margin-bottom: 0;
    @extend .clanprobook;

    .list-group-item {
      padding: 25px;
      margin: 0;
      border-width: 0 0 1px 0;

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        border: none;
        padding-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue